export interface OptionsForTransform {
  valueDefault: number | string;
  labelDefault: string;
  labelProp: string;
  valueProp: string;
}

export interface ComboBoxDataItem {
  label: string;
  value: string | number;
  disabled?: boolean;
}

const defaultConfig: OptionsForTransform = {
  valueDefault: 0,
  labelDefault: 'SELECCIONE',
  labelProp: 'nombre',
  valueProp: 'id'
};

const transformToOptions = (
  rows: Record<string, any>[],
  config?: Partial<OptionsForTransform>
): ComboBoxDataItem[] => {
  const newConfig = Object.assign({}, defaultConfig, config);
  return [
    {
      [newConfig.labelProp]: newConfig.labelDefault,
      [newConfig.valueProp]: newConfig.valueDefault
    },
    ...rows
  ].map((x) => ({
    label: x[newConfig.labelProp],
    value: x[newConfig.valueProp],
    disabled: x[newConfig.valueProp] === newConfig.valueDefault
  }));
};

export default transformToOptions;
